var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTask = function SvgTask(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 489.6 489.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434.65 52.2h-96.6V18c0-9.9-8.1-18-18-18h-150.4c-9.9 0-18 8.1-18 18v94.7c0 9.9 8.1 18 18 18h111.2c9.9 0 18-8.1 18-18s-8.1-18-18-18h-93.2V36h114.5v34.2c0 9.9 8.1 18 18 18h96.6v365.4H72.95V88.2h27.5c9.9 0 18-8.1 18-18s-8.1-18-18-18h-45.5c-9.9 0-18 8.1-18 18v401.4c0 9.9 8.1 18 18 18h379.7c9.9 0 18-8.1 18-18V70.2c0-9.9-8.1-18-18-18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M327.75 217c-7-7.1-18.4-7.1-25.5-.1l-83.9 83.2-30.7-30.9c-7-7.1-18.4-7.1-25.5-.1-7.1 7-7.1 18.4-.1 25.5l43.4 43.7c3.5 3.5 8.1 5.3 12.8 5.3 4.6 0 9.2-1.7 12.7-5.2l96.7-95.9c7.1-7 7.1-18.4.1-25.5z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTask, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/task.ed4e0c67.svg";
export { ForwardRef as ReactComponent };